import { uuidv4, type UUID } from "./uuid";

const FIXED_DATE_EVENT_PREFIX = "date-only-";
const LAST_MOMENT_SEND_PREFIX = "last-moment-send-";

export function isFixedDateEvent(key?: string | null): boolean {
  return key?.startsWith(FIXED_DATE_EVENT_PREFIX) ?? false;
}

export function isLastMomentSendEvent(key?: string | null): boolean {
  return key?.startsWith(LAST_MOMENT_SEND_PREFIX) ?? false;
}

export function createFixedDateEventKey(): string {
  return `${FIXED_DATE_EVENT_PREFIX}${uuidv4()}`;
}

export function createLastMomentSendEventKey(moment_id: UUID): string {
  return `${LAST_MOMENT_SEND_PREFIX}${moment_id}`;
}
